const Loading = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-white">
            <img
                src="/storyverse.svg"
                alt="Loading..."
                className="w-16 h-16 mb-4 animate-spin-slow"
            />
            <p className="text-gray-600 text-lg font-medium">Loading...</p>
        </div>
    )
}

export default Loading
